import axios from "axios";
import { BrandRFMSetting } from "../models/brandRFMSetting";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

export const brandRFMSettingApi = {
  getBrandRFMSettings: async (token: string, brandId: string) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/GetBrandRFMSettings`,
      { brandId: brandId },
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
  updateAllBrandRFMSetting: async (
    token: string,
    listBrandRFMSetting: BrandRFMSetting[]
  ) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/UpdateAllBrandRFMSetting`,
      listBrandRFMSetting,
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
  getDefaultBrandRFMSetting: async (token: string, brandId: string) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/GetDefaultBrandRFMSetting`,
      { brandId: brandId },
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },

  resetBrandRFMSetting: async (token: string, brandId: string) => {
    return axios.post(
      `${API_BASE_URL}/v1/RFM/ResetBrandRFMSetting`,
      { brandId: brandId },
      {
        headers: {
          Authorization: `Basic ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
  },
};
